import { Users } from "lucide-react";

import { pluralize } from "@/components/helpers/string-utils";
import { COMPONENT_DETAILS_PATHS } from "@/components/pages_logged_in/program/components/component-utils";
import { Button } from "@/components/ui/button";
import { ComponentTypeEnum } from "@/graphql";
import { LeadComponent } from "@/types/programs";

interface AllParticipantComponentTagProps {
  programId: string;
  component: LeadComponent;
  isProgramLead: boolean;
}

export function AllParticipantComponentTag({
  programId,
  component,
  isProgramLead,
}: AllParticipantComponentTagProps) {
  if (!isProgramLead) {
    return null;
  }

  const { status } = component || {};

  const forAllParticipants = component?.forAllParticipants;
  const totalParticipants = component?.totalParticipants || 0;
  const totalParticipantsText = pluralize({
    amount: totalParticipants,
    singular: "Participant",
    plural: "Participants",
  });

  const canViewSurveyStatistic = true;

  const onClick = () => {
    if (canViewSurveyStatistic) {
      const path = COMPONENT_DETAILS_PATHS?.[component?.type];
      window.location.href = `/programs/${programId}/${path}/${component?.id}#participant-table`;
    }
  };

  const componentHasComponentItemPanel =
    component?.type !== ComponentTypeEnum.Announcement &&
    component?.type !== ComponentTypeEnum.GroupMeeting;

  if (
    ["Ongoing", "Completed"].indexOf(status) > -1 &&
    !forAllParticipants &&
    componentHasComponentItemPanel
  ) {
    // Because ComponentItemPanel has same logic show participant number, we return null here to avoid duplicate
    // If component is for all participants, we still want to show this tag
    return null;
  }

  return (
    <Button
      onClick={onClick}
      intent="secondary"
      variant="outline"
      size="sm"
      disabled={!canViewSurveyStatistic}
      className="h-[38px]"
    >
      <div className="flex items-center gap-2">
        <Users className="size-3.5 text-gray-500" />
        <span>
          {forAllParticipants ? "All Participants" : totalParticipantsText}
        </span>
      </div>
    </Button>
  );
}
